"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNumberItemValue = void 0;

var isNumberItemValue = function isNumberItemValue(value) {
  return 'N' in value;
};

exports.isNumberItemValue = isNumberItemValue;